import { render, staticRenderFns } from "./CustomCounter.vue?vue&type=template&id=a88a3526&"
import script from "./CustomCounter.vue?vue&type=script&lang=js&"
export * from "./CustomCounter.vue?vue&type=script&lang=js&"
import style0 from "./CustomCounter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports